import { createReactComponentFromLit } from '@affine/component';
import {
  defineMateMark,
  MateMark,
} from '@affine/core/blocksuite/ai/components/mate-mark/mate-mark';
import React from 'react';

// The island renders before the editor effects run.
defineMateMark();

export const MateMarkView = createReactComponentFromLit({
  react: React,
  elementClass: MateMark,
});
